// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templateDefault from "./partials/template-default";
import pageTemplateDefault from "./partials/page-template-default";
import singlePost from "./partials/single-post";
import templateContacts from "./partials/template-contacts";
import templateServices from "./partials/template-services";
import templateProducts from "./partials/template-products";
import Search from "./partials/page-search";

// Populate Router instance with DOM routes
const routes = new Router({
  templateDefault,
  pageTemplateDefault,
  templateHome,
  singlePost,
  templateContacts,
  templateServices,
  templateProducts,
  Search,
});

// Load Events
routes.loadEvents();
